import albertJrImage from "@/assets/team/albert-saunders.jpeg";
import ucheImage from "@/assets/team/uche-obi.jpeg";
import aaronImage from "@/assets/team/aaron-herring.jpeg";
import kenonImage from "@/assets/team/kenon-lattimore.jpeg";
import steveImage from "@/assets/team/steve-griffin.png";
import albertSrImage from "@/assets/team/albert-saunders-sr.png";
import antwonImage from "@/assets/team/antwon-salisbury.jpeg";
import albertJrCard from "@/assets/team-cards/albert-oneil-saunders-jr-card.png.asset.json";
import ucheCard from "@/assets/team-cards/uche-obi-card.png.asset.json";
import albertSrCard from "@/assets/team-cards/albert-saunders-sr-card.png.asset.json";
import kenonCard from "@/assets/team-cards/kenon-lattimore-card.png.asset.json";
import steveCard from "@/assets/team-cards/steve-griffin-card.png.asset.json";
import aaronCard from "@/assets/team-cards/aaron-herring-card.png.asset.json";
import antwonCard from "@/assets/team-cards/antwon-salisbury-card.png.asset.json";
import shaunCard from "@/assets/team-cards/shaun-booysen-card.png.asset.json";
import brannakinCard from "@/assets/team-cards/brannakin-jacobs-card.png.asset.json";
import jewelCard from "@/assets/team-cards/jewel-brooks.png.asset.json";
import reubinCard from "@/assets/team-cards/reubin-alston.png.asset.json";
import micheleCard from "@/assets/team-cards/michele-tyree.png.asset.json";
import samuelCard from "@/assets/team-cards/samuel-banks.png.asset.json";
import ashliCard from "@/assets/team-cards/ashli-saunders.png.asset.json";

export type TeamCategory =
  | "Executive Leadership"
  | "Administration"
  | "Sales & Business Transformation Leadership"
  | "Technology & Robotics Team";

export interface TeamMember {
  slug: string;
  name: string;
  title: string;
  subtitle: string;
  image: string;
  cardImage: string;
  shortBio: string;
  fullBio: string;
  expertise: string[];
  industryExperience: string[];
  certifications: string[];
  areasServed: string[];
  linkedin: string;
  contactUrl: string;
  category: TeamCategory;
  featured: boolean;
}

export const TEAM_BOOKING_URL = "https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics";
export const TEAM_CALL_URL = "tel:+13369624539";
export const TEAM_CALL_DISPLAY = "(336) 962-4539";
export const COMPANY_LINKEDIN_URL = "https://www.linkedin.com/company/neil-ai-global-solutions";
export const ORGANIZATION_NAME = "Neil AI Global Solutions";
export const ORGANIZATION_URL = "https://neilaiglobalsolutionsllc.net";

export const teamMembers: TeamMember[] = [
  {
    slug: "albert-oneil-saunders-jr",
    name: "Albert O’Neil Saunders Jr.",
    title: "CEO & Founder",
    subtitle: "AI, Automation & Robotics Leadership",
    image: albertJrImage,
    cardImage: albertJrCard.url,
    shortBio:
      "Founder of Neil AI Global Solutions and visionary behind the company’s mission to help businesses leverage Artificial Intelligence, Automation, and Robotics to increase efficiency, improve customer experiences, and support employees.",
    fullBio:
      "Albert O’Neil Saunders Jr. is the founder and chief executive behind Neil AI Global Solutions. He leads the company’s vision, growth strategy, and market positioning across AI automation, robotics integration, workflow modernization, and client transformation. Albert works directly with business owners and leadership teams to turn complex automation opportunities into practical systems that improve operations, elevate customer experiences, and support employees instead of replacing them. His leadership continues to shape Neil AI as a trusted technology partner for organizations seeking future-ready operations.",
    expertise: [
      "AI automation strategy",
      "Robotics deployment planning",
      "Business transformation consulting",
      "Operational efficiency systems",
      "Customer experience modernization"
    ],
    industryExperience: [
      "Healthcare",
      "Hospitality",
      "Restaurants",
      "Commercial cleaning",
      "Warehousing",
      "Retail"
    ],
    certifications: [
      "AI automation strategy leadership",
      "Robotics deployment consulting",
      "Business workflow modernization"
    ],
    areasServed: ["Greensboro", "North Carolina", "Southeast United States", "Nationwide virtual consulting"],
    linkedin: "https://www.linkedin.com/in/albert-saunders-62a26137a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "samuel-banks",
    name: "Samuel Banks",
    title: "Chief Investment Officer",
    subtitle: "Board Member | Capital Strategy, Investor Relations & Growth Financing",
    image: samuelCard.url,
    cardImage: samuelCard.url,
    shortBio:
      "Board member and Chief Investment Officer guiding capital strategy, investor relations, and growth financing across Robotics-as-a-Service, Enterprise AI & Automation, and AI Music divisions.",
    fullBio:
      "Samuel Banks brings more than 18 years of business and technology leadership to his role as Chief Investment Officer of Neil AI Global Solutions, where he guides the company’s capital strategy, investor relations, and growth financing across its Robotics-as-a-Service, Enterprise AI & Automation, and AI Music divisions. A Morehouse College graduate, Samuel began his career in Information Technology, working with firms including Intel, Kaiser Permanente, Dell, Restaurant Technologies Incorporated, and InstallShield, where he developed a strong foundation in logistics planning, sales development, joint venture structuring, and enterprise deployment. He currently also serves as President of Hybrid Business Services (d.b.a. Zaffer Corporation), with a track record of building and scaling growth-stage organizations across multiple business verticals. Samuel’s experience spans high-stakes environments including airports, military installations, and state government, where he helped create leading .NET accounting systems, self-service technology platforms, and out-of-home TV networks. He also founded one of the fastest-growing PLU data collection companies serving airports, hospitals, stadiums, and transit concession locations nationwide.",
    expertise: [
      "Capital strategy",
      "Investor relations",
      "Growth financing",
      "Joint venture structuring",
      "Enterprise technology deployment"
    ],
    industryExperience: [
      "Enterprise technology",
      "Aviation and transit concessions",
      "Healthcare",
      "Government and military",
      "Hospitality and food service"
    ],
    certifications: [
      "Morehouse College graduate",
      "Executive investment leadership",
      "Growth-stage scaling strategy"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Nationwide investor relations"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "uche-obi",
    name: "Uche Obi",
    title: "Chief Operating Officer",
    subtitle: "Implementation, Deployment & Client Success",
    image: ucheImage,
    cardImage: ucheCard.url,
    shortBio:
      "Operations leader focused on implementation, deployment, client success, business transformation, and operational excellence.",
    fullBio:
      "Uche Obi oversees execution across client onboarding, internal delivery, implementation planning, and operational systems. He helps translate Neil AI’s automation and robotics solutions into repeatable deployment frameworks that drive measurable business outcomes. Uche is focused on operational excellence, ensuring that projects move smoothly from strategy to rollout, with the accountability, structure, and support needed for long-term success.",
    expertise: [
      "Operations leadership",
      "Implementation management",
      "Client onboarding",
      "Deployment coordination",
      "Business transformation"
    ],
    industryExperience: [
      "Commercial operations",
      "Financial services",
      "Automotive",
      "Logistics",
      "Enterprise service delivery"
    ],
    certifications: [
      "Operational process leadership",
      "Client success enablement",
      "Deployment and implementation strategy"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Nationwide operations support"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/uche-obi-personal-calendar-kvvpufn1m",
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "albert-saunders-sr",
    name: "Albert Saunders Sr.",
    title: "Chief Financial Officer",
    subtitle: "Financial Oversight, Growth Planning & Risk Management",
    image: albertSrImage,
    cardImage: albertSrCard.url,
    shortBio:
      "Financial strategist responsible for financial oversight, growth planning, risk management, and organizational sustainability.",
    fullBio:
      "Albert Saunders Sr. provides financial leadership for Neil AI Global Solutions, helping guide the company’s long-term planning, fiscal discipline, and responsible growth. He supports strategic decision-making around expansion, sustainability, and risk management, ensuring the company is positioned for durable success as demand for AI and robotics solutions continues to grow. His experience reinforces the company’s credibility with clients, partners, and stakeholders.",
    expertise: [
      "Financial oversight",
      "Growth planning",
      "Risk management",
      "Strategic budgeting",
      "Organizational sustainability"
    ],
    industryExperience: [
      "Executive finance",
      "Business leadership",
      "Organizational development",
      "Strategic planning"
    ],
    certifications: [
      "Executive financial leadership",
      "Strategic growth planning",
      "Risk and governance stewardship"
    ],
    areasServed: ["North Carolina", "Southeast United States"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "kenon-lattimore",
    name: "Kenon Lattimore",
    title: "Chief of Staff",
    subtitle: "Internal Operations, CRM Systems & Automation Deployment",
    image: kenonImage,
    cardImage: kenonCard.url,
    shortBio:
      "Leads internal operations, project execution, client onboarding, implementation support, CRM systems, and automation deployment.",
    fullBio:
      "Kenon Lattimore leads internal coordination across project execution, CRM workflow management, onboarding, and implementation support. He helps keep Neil AI’s delivery engine aligned, ensuring sales, operations, and client success teams stay connected through clear systems and consistent execution. Kenon plays a key role in helping new clients move from signed agreement to successful deployment with confidence.",
    expertise: [
      "Client onboarding",
      "CRM systems",
      "Project execution",
      "Implementation support",
      "Automation deployment"
    ],
    industryExperience: [
      "Operations support",
      "Client services",
      "Automation systems",
      "Internal process coordination"
    ],
    certifications: [
      "CRM workflow implementation",
      "Automation deployment support",
      "Project execution leadership"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Remote CRM support nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/kenon-lattimore-personal-calendar-xmfjnkrgr",
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "steve-griffin",
    name: "Steve Griffin",
    title: "VP of Sales & Head of Robotics",
    subtitle: "Enterprise Partnerships & Robotics Deployments",
    image: steveImage,
    cardImage: steveCard.url,
    shortBio:
      "Leads robotics growth initiatives, sales strategy, enterprise partnerships, and robotics deployments.",
    fullBio:
      "Steve Griffin leads Neil AI’s robotics growth strategy, managing enterprise sales conversations, solution alignment, and deployment readiness for organizations investing in automation. He works closely with business decision-makers to identify the right robotics fit, communicate ROI, and guide clients through discovery, planning, and rollout. Steve’s leadership helps bridge the gap between opportunity and execution for robotics buyers across multiple industries.",
    expertise: [
      "Robotics sales strategy",
      "Enterprise partnerships",
      "Deployment planning",
      "ROI-focused solution selling",
      "Commercial robotics consulting"
    ],
    industryExperience: [
      "Hospitality",
      "Healthcare",
      "Warehousing",
      "Restaurants",
      "Commercial cleaning"
    ],
    certifications: [
      "Robotics solutions advisory",
      "Commercial deployment leadership",
      "Enterprise sales strategy"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Enterprise accounts nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Sales & Business Transformation Leadership",
    featured: true,
  },
  {
    slug: "aaron-herring",
    name: "Aaron L. Herring",
    title: "General Manager",
    subtitle: "Operations Leadership, AI, Automation & Robotics Deployment",
    image: aaronImage,
    cardImage: aaronCard.url,
    shortBio:
      "Leads day-to-day operations, client deployments, and the advisory team driving AI, automation, and robotics adoption.",
    fullBio:
      "As General Manager, Aaron L. Herring leads day-to-day operations at Neil AI Global Solutions — overseeing client deployments, the business transformation advisory team, and the delivery standards that keep every installation on schedule. He works directly with leadership teams to assess current workflows, identify friction points, and implement technology that reduces repetitive effort, increases service consistency, and creates room for growth. Aaron’s approach is grounded in real-world improvement, not hype.",
    expertise: [
      "Operations leadership",
      "Client deployment management",
      "Business transformation advisory",
      "AI opportunity assessment",
      "Robotics solution mapping",
      "Workflow modernization"
    ],
    industryExperience: [
      "Service businesses",
      "Hospitality",
      "Retail",
      "Logistics",
      "Healthcare operations"
    ],
    certifications: [
      "Operations and deployment leadership",
      "AI and robotics advisory support",
      "Operational efficiency planning"
    ],
    areasServed: ["North Carolina", "Triad region", "Nationwide client deployments"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "antwon-salisbury",
    name: "Antwon Salisbury",
    title: "Sr Business Transformation Advisor",
    subtitle: "Technology Solutions for Efficiency & Customer Experience",
    image: antwonImage,
    cardImage: antwonCard.url,
    shortBio:
      "Helps businesses implement practical technology solutions that improve efficiency and customer experiences.",
    fullBio:
      "Antwon Salisbury works with businesses that want to adopt smarter systems without adding unnecessary complexity. He helps clients evaluate operational challenges, prioritize practical solutions, and move toward AI and robotics deployments that improve both internal efficiency and the customer experience. His focus is on actionable transformation that delivers value quickly and sustainably.",
    expertise: [
      "Business transformation advisory",
      "Customer experience improvement",
      "Automation planning",
      "Technology solution alignment",
      "Efficiency consulting"
    ],
    industryExperience: [
      "Retail",
      "Hospitality",
      "Restaurants",
      "Commercial services",
      "Local business operations"
    ],
    certifications: [
      "AI and automation advisory",
      "Operational improvement consulting",
      "Client discovery and solution mapping"
    ],
    areasServed: ["North Carolina", "Southeast United States"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: "https://api.leadconnectorhq.com/widget/bookings/salisbury-antwon-business-calendar-neilai",
    category: "Sales & Business Transformation Leadership",
    featured: false,
  },
  {
    slug: "shaun-booysen",
    name: "Shaun Booysen",
    title: "Director of Operations",
    subtitle: "Senior Business Transformation Advisor · Cape Town, South Africa",
    image: shaunCard.url,
    cardImage: shaunCard.url,
    shortBio:
      "Leads Neil AI Global Solutions’ operational growth and business-transformation initiatives across Cape Town, South Africa and the broader African market.",
    fullBio:
      "Shaun Booysen leads Neil AI Global Solutions’ operational growth and business-transformation initiatives in Cape Town, South Africa. He supports market development, client engagement, operational strategy, AI and robotics adoption, and the implementation of business-automation solutions across the African market.",
    expertise: [
      "South Africa market development",
      "African expansion strategy",
      "Operational leadership",
      "Business transformation",
      "AI adoption",
      "Commercial robotics",
      "Enterprise implementation",
      "Strategic partnerships",
      "Workforce modernization",
    ],
    industryExperience: [
      "Enterprise operations",
      "Commercial robotics",
      "Business transformation",
      "AI adoption programs",
    ],
    certifications: [
      "Business transformation advisory",
      "Operational leadership",
      "AI & robotics adoption strategy",
    ],
    areasServed: ["Cape Town", "South Africa", "African market"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Executive Leadership",
    featured: true,
  },
  {
    slug: "brannakin-jacobs",
    name: "Brannakin Jacobs",
    title: "Director of Technical Operations",
    subtitle: "Robotics Deployment & Field Implementation",
    image: brannakinCard.url,
    cardImage: brannakinCard.url,
    shortBio:
      "Leads technical operations, robotics deployment, implementation readiness, field operations, installation support, troubleshooting, and quality assurance.",
    fullBio:
      "Brannakin Jacobs leads technical operations for Neil AI Global Solutions, overseeing robotics deployment, implementation readiness, technical coordination, field operations, installation support, troubleshooting, and quality assurance for commercial robotics and AI-enabled solutions.",
    expertise: [
      "Technical operations",
      "Robotics deployments",
      "Installation coordination",
      "Field implementation",
      "Technical quality assurance",
      "Troubleshooting",
      "Deployment readiness",
      "Customer handoff",
      "Technical training",
      "Operational support",
    ],
    industryExperience: [
      "Commercial robotics",
      "Enterprise deployment",
      "On-site installation",
      "Field service operations",
    ],
    certifications: [
      "Certified PUDU deployment lead",
      "Robotics implementation",
      "Technical quality assurance",
    ],
    areasServed: ["North Carolina", "Southeast United States", "National deployment support"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Technology & Robotics Team",
    featured: true,
  },
  {
    slug: "michael-tyree",
    name: "Pastor Michael Tyree",
    title: "Business Transformation Advisor",
    subtitle: "Leadership, Relationships & Operational Transformation",
    image: micheleCard.url,
    cardImage: micheleCard.url,
    shortBio:
      "Business Transformation Advisor blending leadership, entrepreneurship, communication, and ministry experience to help organizations navigate meaningful change with AI, robotics, and RaaS.",
    fullBio:
      "Pastor Michael Tyree serves as a Business Transformation Advisor at Neil AI Global Solutions, bringing a unique combination of leadership, entrepreneurship, communication, ministry, and service-centered experience to the company’s growing team.\n\nAs a business professional and visionary leader, Pastor Tyree has developed a strong ability to connect with people, understand their needs, build trusted relationships, and help individuals and organizations navigate meaningful change. His background reflects years of working directly with people and leading with a commitment to service, integrity, and positive impact.\n\nAt Neil AI Global Solutions, he works with business owners and organizational leaders to identify operational challenges, uncover opportunities for improvement, and explore how Artificial Intelligence, commercial robotics, intelligent automation, and Robotics-as-a-Service (RaaS) can support their organizations.\n\nIn his role, he helps bridge the gap between emerging technology and practical business needs. Pastor Tyree focuses on understanding each organization’s goals before helping connect decision-makers with Neil AI solutions designed to improve efficiency, productivity, customer experience, workforce support, and long-term operational scalability.\n\nBeyond business, his background in ministry has strengthened his abilities as a communicator, relationship builder, and leader. His senior pastoral leadership at Greater Faith Ministries in Winston-Salem, North Carolina, reflects a longstanding commitment to helping people and strengthening communities.\n\nPastor Tyree brings that same people-first perspective to Neil AI—recognizing that successful transformation is not simply about introducing new technology. It is about understanding people, identifying real operational needs, and implementing solutions that create measurable value.\n\nAs a Business Transformation Advisor, Pastor Michael Tyree represents Neil AI’s commitment to helping organizations confidently prepare for the next generation of business.\n\nAutomate. Elevate. Dominate.™",
    expertise: [
      "Business transformation advisory",
      "Relationship building & communication",
      "Operational needs discovery",
      "AI, robotics & RaaS solution alignment",
      "Leadership & organizational change"
    ],
    industryExperience: [
      "Faith-based organizations",
      "Small business & entrepreneurship",
      "Community & service organizations",
      "Commercial services"
    ],
    certifications: [
      "Business transformation advisory",
      "Leadership & ministry service"
    ],
    areasServed: ["Winston-Salem", "North Carolina", "Southeast United States", "Remote consultations nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Sales & Business Transformation Leadership",
    featured: false,
  },
  {
    slug: "reubin-alston",
    name: "Reubin Alston",
    title: "Business Transformation Advisor",
    subtitle: "Workforce Support & Automation Strategy",
    image: reubinCard.url,
    cardImage: reubinCard.url,
    shortBio:
      "Advises organizations on automation that supports their workforce instead of replacing it.",
    fullBio:
      "Reubin Alston works with organizations facing labor shortages and rising operational pressure. He helps leadership teams map current workflows, quantify the cost of repetitive labor, and build a deployment plan for AI automation and robotics that supports existing staff. His focus is on adoption that employees welcome — technology that removes the worst parts of the job while raising service consistency.",
    expertise: [
      "Workforce support strategy",
      "Labor shortage solutions",
      "Automation planning",
      "Business transformation advisory",
      "Client onboarding"
    ],
    industryExperience: [
      "Healthcare operations",
      "Senior living",
      "Logistics",
      "Commercial cleaning"
    ],
    certifications: [
      "AI and automation advisory",
      "Workflow assessment and planning"
    ],
    areasServed: ["North Carolina", "Southeast United States", "Remote consultations nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Sales & Business Transformation Leadership",
    featured: false,
  },
  {
    slug: "jewel-brooks",
    name: "Jewel N. Brooks",
    title: "Data & Automation Manager",
    subtitle: "Data Engineering, Analytics & Workflow Automation",
    image: jewelCard.url,
    cardImage: jewelCard.url,
    shortBio:
      "Data & Automation Manager with 12+ years in data engineering, analytics, enterprise technology, reporting, and workflow automation — turning large datasets into actionable business intelligence.",
    fullBio:
      "Jewel N. Brooks serves as Data & Automation Manager at Neil AI Global Solutions, bringing more than 12 years of experience in data engineering, analytics, enterprise technology, reporting, and workflow automation. Her expertise includes building scalable data pipelines, automating complex business processes, developing enterprise reporting solutions, and transforming large datasets into actionable business intelligence.\n\nThroughout her career, Jewel has worked extensively within complex healthcare and enterprise environments. Her technical expertise includes SQL, Power BI, SSIS, SSRS, C#, Azure DevOps, Power Automate, Microsoft 365, SharePoint, and enterprise application development.\n\nJewel has demonstrated a strong ability to turn technology into measurable operational results. She developed ETL processes consolidating more than 600,000 patient records and 50,000 donor records, helping automate data operations and reduce manual processing time by approximately 90%. She also spearheaded the consolidation of more than 75 SSRS reports into five Power BI reports, supporting executive decision-making across capital campaigns, event planning, donor engagement, and other strategic initiatives.\n\nHer background also includes extensive experience in technology education. Jewel served as a Computer Information Systems instructor, teaching subjects including SQL Server, database design, web development, networking, and programming concepts, giving her the ability not only to build sophisticated technology solutions but also to communicate complex technical concepts effectively.\n\nJewel holds both a Master of Science in Computer Science and a Bachelor of Science in Computer Science from North Carolina Agricultural & Technical State University. She is also a Microsoft Certified Power BI Data Analyst Associate and holds certifications in AWS Cloud Foundations and ITIL Foundation – IT Service Management.\n\nAt Neil AI Global Solutions, Jewel helps lead the company’s data and automation initiatives, applying her experience in analytics, workflow automation, business intelligence, and enterprise systems to help organizations modernize operations and make better use of their data.\n\nHer combination of technical expertise, enterprise experience, automation knowledge, and business intelligence capabilities supports Neil AI’s mission to help organizations Automate. Elevate. Dominate.™",
    expertise: [
      "Data engineering & ETL pipelines",
      "Power BI & enterprise reporting",
      "SQL, SSIS, SSRS",
      "Workflow automation (Power Automate)",
      "Business intelligence & analytics",
      "C#, Azure DevOps, Microsoft 365, SharePoint"
    ],
    industryExperience: [
      "Healthcare",
      "Nonprofit & donor operations",
      "Enterprise technology",
      "Higher education"
    ],
    certifications: [
      "M.S. Computer Science — North Carolina A&T State University",
      "B.S. Computer Science — North Carolina A&T State University",
      "Microsoft Certified: Power BI Data Analyst Associate",
      "AWS Cloud Foundations",
      "ITIL Foundation – IT Service Management"
    ],
    areasServed: ["North Carolina", "Nationwide", "Remote implementation"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Technology & Robotics Team",
    featured: false,
  },
  {
    slug: "ashli-saunders",
    name: "Ashli Saunders",
    title: "Chief Administrator",
    subtitle: "Administration, Training & Internal Operations",
    image: ashliCard.url,
    cardImage: ashliCard.url,
    shortBio:
      "Chief Administrator strengthening the people, processes, training standards, and internal systems behind Neil AI’s growth in AI, robotics, and RaaS.",
    fullBio:
      "Ashli Saunders serves as Chief Administrator of Neil AI Global Solutions, helping strengthen the people, processes, and systems that support the company’s continued growth in artificial intelligence, commercial robotics, intelligent automation, and Robotics-as-a-Service (RaaS).\n\nWorking alongside Founder & CEO Albert O’Neil Saunders Jr., Ashli plays an integral role in translating the company’s vision into organized, consistent execution. She oversees key areas of administration, training and development, compliance coordination, internal operations, and Neil AI software systems, helping ensure the company’s growing team has the structure, resources, and standards necessary to perform at a high level.\n\nWith experience spanning AI automation, Neil AI software, marketing automation, workflow coordination, employee training, client communication, compliance, and cross-functional team support, Ashli brings a detail-oriented and people-centered approach to organizational leadership. She is recognized for her professionalism, proactive communication, accountability, and ability to transform complex information into clear, practical processes.\n\nAs Neil AI expands across industries and markets, Ashli helps establish the operational discipline and internal infrastructure required to scale responsibly — supporting onboarding, strengthening training standards, improving workflows, and maintaining consistency throughout the organization.\n\nIn addition to her technology and administrative leadership experience, Ashli is a licensed esthetician, bringing an entrepreneurial background rooted in client care, professionalism, and service excellence.\n\nAs both a business leader and the wife of Neil AI’s Founder & CEO, Ashli has a unique connection to the company’s mission and long-term vision. Her leadership reflects a commitment to building an organization where innovation is supported by structure, growth is supported by accountability, and people are equipped to succeed.\n\nAutomate. Elevate. Dominate.™",
    expertise: [
      "Administration and internal operations",
      "Training and development",
      "Compliance coordination",
      "Neil AI software systems",
      "AI and marketing automation",
      "Workflow coordination and onboarding",
      "Client communication",
    ],
    industryExperience: [
      "Artificial intelligence and automation",
      "Commercial robotics and RaaS",
      "Professional and client services",
    ],
    certifications: ["Licensed Esthetician", "Executive administration", "Training & compliance coordination"],
    areasServed: ["Greensboro", "North Carolina", "Nationwide"],
    linkedin: COMPANY_LINKEDIN_URL,
    contactUrl: TEAM_BOOKING_URL,
    category: "Administration",
    featured: false,
  },
];

export const executiveLeadership = teamMembers.filter((member) => member.category === "Executive Leadership");
export const administrationTeam = teamMembers.filter((member) => member.category === "Administration");
export const salesLeadership = teamMembers.filter((member) => member.category === "Sales & Business Transformation Leadership");
export const technologyTeam = teamMembers.filter((member) => member.category === "Technology & Robotics Team");

export const getTeamMemberBySlug = (slug?: string) =>
  teamMembers.find((member) => member.slug === slug);
